import React, { Component, PropTypes } from 'react';
import baseUrl from '../../../utils/baseUrl';
import ContentBlock from '../block/content';
import InputTagSelect from '../../form/tagselect/tagselect';
import ConfirmDialog from '../../form/confirm';

import axios from 'axios';
import qs from 'qs';

export class FormJoinProfile extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		userRequests: PropTypes.array,
	};
	static defaultProps = {};

	constructor(props) {
		super();

		this.state = {
			applied: false,
		};
	}

	render() {
		let pendingRequestStatus = false;
		let profileName = '';
		if (this.props.userRequests && this.props.userRequests.length) {
			pendingRequestStatus = this.props.userRequests[0].stateAsText;
			profileName = this.props.userRequests[0].profileName;
		}

		return (
			<ContentBlock title={'Join profile'}>
				{(!pendingRequestStatus) && (
					<div>
						<InputTagSelect
							ref='profile'
							name='profile'
							placeholder='Type to search for FWA Profiles'
							maxSelected={1}
							canDelete={false}
							path='/api/profiles/search'
							onChange={(e) => this.onSubmit(e)}
						/>

						<ConfirmDialog ref='confirm' />

						<div className='cf'></div>

						{(!!this.state.applied) && (
							<p>Request to join has been sent.</p>
						)}
					</div>
				) || (
					<div>
						<p>Request to join {profileName || 'a profile'} is pending.</p>
					</div>
				)}


			</ContentBlock>

		);
	}

	getRefs() {
		return this.refs;
	}

	onSubmit(e) {
		if (e.value && e.value.length) {
			if (this.lastProfileValue === e.value[0].id) {
				return false;
			}
			this.lastProfileValue = e.value[0].id;

			this.refs.confirm.confirm(`Are you sure you want to join ${e.value[0].name}`)
			.then(() => {
				axios.post(baseUrl + '/api/account/profiles/join', qs.stringify({
					profile: e.value[0].id,
				}))
				.then((res) => {
					this.setState({
						...this.state,
						applied: true,
					});
				})
				.catch((res) => {
					this.props.dispatch(dispatchError(res.data));
				});
			})
			.catch(() => {
				console.log('PROFILE:');
				console.log(this.refs.profile);
				this.refs.profile.delete(e.value);
				this.lastProfileValue = false; // hack to make the same profile selectable again
			});
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/profileEdit/formJoinProfile.js
 **/